import { gql } from '@apollo/client'
import { BLOCKS } from './fragments/BLOCKS.gql';
import { HEAD_META } from './fragments/HEAD_META.js';
import { LANGUAGE_SWITCH } from './fragments/LANGUAGE_SWITCH.gql';
import { IMAGES } from './fragments/IMAGES'
import { NAVIGATION } from './fragments/NAVIGATION.gql';

export const HOME_PAGE_QUERY = gql`
  ${NAVIGATION}
  ${LANGUAGE_SWITCH}
  ${BLOCKS}
  query ($siteHandle: [String]) {
    entry(site: $siteHandle, section: "homepage") {
      ... on homepage_Entry {
        ${HEAD_META()}
        mainTitle
        title
        id
        languageSwitch {
          ...languageSwitch
        }
        image {
          ${IMAGES('pageHalfImageFullHeight')}
        }
        linkTitle
        linkTitle2
        ctaUrl {
          type
          url
        }
        ctaUrl2 {
          type
          url
        }
        homepageSlider {
          ... on slide_Entry{
            id
            mainTitle
            image {
              ${IMAGES('pageTwoColumnImageBig')}
            }
            linkTitle
            ctaUrl {
              type
              url
            }
          }
        }
        blocks {
          ...blocks
        }
      }
    }

    globalSet(site: $siteHandle, handle: "navigation") {
      ...navigation
    }
  }
`;
